import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Svg,
  Circle,
  Path,
  Defs,
  G,
  Rect,
  Link,
} from "@react-pdf/renderer";
import background from "./background.png";
import courseDescription from "./courseDescription.svg";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";

const coursebackgroundImage =
  "https://commons-image.s3.ap-south-1.amazonaws.com/coursebg.png";

const pagebackgroundImage =
  "https://commons-image.s3.ap-south-1.amazonaws.com/pdfbg.png";

const nurtureLogo =
  "https://commons-image.s3.ap-south-1.amazonaws.com/ntrlogo.png";

const CourseBackground = () => (
  <Image
    src={coursebackgroundImage}
    style={{ width: "100%", height: "100%" }}
  />
);

const PageBackground = () => (
  <Image
    src={pagebackgroundImage}
    style={{
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: -1,
      top: 0,
      left: 0,
    }}
  />
);

function convertHtmlToText(html: any) {
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || "";
}

function CoursePdf(props: any) {
  const { courseDetails, instituteDetails } = props;
  const hasLogo = Boolean(instituteDetails?.logo);

  const renderCertificateTag = () => {
    if (courseDetails?.isCertificateProvided) {
      return (
        <View
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            backgroundColor: "#E7E9EA",
            borderRadius: "4.813px",
            padding: 5,
          }}
        >
          <Svg width="20" height="19" viewBox="0 0 20 19">
            <G clip-path="url(#clip0_12309_62400)">
              <Path
                d="M19.195 0.318909H1.41667C1.33808 0.318909 1.26272 0.350126 1.20715 0.405695C1.15158 0.461263 1.12036 0.536629 1.12036 0.615214V15.4305C1.12036 15.5091 1.15158 15.5844 1.20715 15.64C1.26272 15.6956 1.33808 15.7268 1.41667 15.7268H7.63908V18.3935C7.63923 18.444 7.65229 18.4937 7.67703 18.5377C7.70176 18.5818 7.73734 18.6187 7.78038 18.6452C7.82343 18.6716 7.87252 18.6866 7.92298 18.6887C7.97345 18.6908 8.02362 18.68 8.06872 18.6573L10.3058 17.5402L12.5429 18.6573C12.5842 18.6784 12.6299 18.6896 12.6763 18.6898C12.7317 18.69 12.7862 18.6746 12.8333 18.6454C12.876 18.6187 12.9112 18.5816 12.9356 18.5375C12.9599 18.4934 12.9727 18.4439 12.9726 18.3935V15.7268H19.195C19.2736 15.7268 19.3489 15.6956 19.4045 15.64C19.4601 15.5844 19.4913 15.5091 19.4913 15.4305V0.615214C19.4913 0.536629 19.4601 0.461263 19.4045 0.405695C19.3489 0.350126 19.2736 0.318909 19.195 0.318909ZM6.59312 12.4497C6.54196 12.2649 6.45542 12.0918 6.3383 11.94C6.24997 11.8357 6.18799 11.7117 6.15755 11.5785C6.18799 11.4453 6.24997 11.3213 6.3383 11.217C6.45542 11.0652 6.54196 10.8921 6.59312 10.7074C6.63154 10.5117 6.63154 10.3104 6.59312 10.1148C6.56218 9.98623 6.56218 9.85218 6.59312 9.72364C6.62868 9.64068 6.76794 9.56364 6.88943 9.4866C7.06057 9.40116 7.2143 9.2846 7.34277 9.14288C7.44984 8.98287 7.52527 8.80384 7.565 8.61546C7.58855 8.4853 7.64234 8.36249 7.72205 8.25693C7.8376 8.20235 7.96477 8.17692 8.09243 8.18285C8.28585 8.1789 8.47681 8.1387 8.65541 8.06433C8.82247 7.96914 8.9694 7.84233 9.08801 7.69099C9.18876 7.58135 9.29839 7.45691 9.38432 7.43616C9.50864 7.44187 9.63012 7.47528 9.73989 7.53395C9.91737 7.61848 10.1096 7.66779 10.3058 7.67914C10.5021 7.66779 10.6943 7.61848 10.8718 7.53395C10.9817 7.47565 11.1031 7.44226 11.2273 7.43616C11.3133 7.45691 11.4229 7.58135 11.5236 7.69099C11.6423 7.84233 11.7892 7.96914 11.9562 8.06433C12.1348 8.1387 12.3258 8.1789 12.5192 8.18285C12.6469 8.17692 12.7741 8.20235 12.8896 8.25693C12.9693 8.36249 13.0231 8.4853 13.0467 8.61546C13.0864 8.80384 13.1618 8.98287 13.2689 9.14288C13.3993 9.29218 13.5572 9.41492 13.7341 9.50438C13.8674 9.58142 14.0067 9.66142 14.0304 9.74142C14.0613 9.86996 14.0613 10.004 14.0304 10.1325C13.992 10.3282 13.992 10.5295 14.0304 10.7252C14.0816 10.9099 14.1681 11.083 14.2852 11.2348C14.3668 11.3351 14.4246 11.4526 14.4541 11.5785C14.4237 11.7117 14.3617 11.8357 14.2734 11.94C14.1562 12.0918 14.0697 12.2649 14.0185 12.4497C13.9801 12.6453 13.9801 12.8466 14.0185 13.0423C14.0495 13.1708 14.0495 13.3048 14.0185 13.4334C13.983 13.5164 13.8437 13.5934 13.7222 13.6704C13.5511 13.7559 13.3974 13.8724 13.2689 14.0141C13.1618 14.1742 13.0864 14.3532 13.0467 14.5416C13.0231 14.6717 12.9693 14.7945 12.8896 14.9001C12.7741 14.9547 12.6469 14.9801 12.5192 14.9742C12.3258 14.9781 12.1348 15.0183 11.9562 15.0927C11.7892 15.1879 11.6423 15.3147 11.5236 15.466C11.4229 15.5757 11.3133 15.7001 11.2273 15.7209C11.103 15.7152 10.9815 15.6818 10.8718 15.6231C10.6941 15.5396 10.5019 15.4913 10.3058 15.4809C10.1096 15.4922 9.91737 15.5415 9.73989 15.626C9.63012 15.6847 9.50864 15.7181 9.38432 15.7238C9.29839 15.7031 9.18876 15.5786 9.08801 15.469C8.9694 15.3177 8.82247 15.1909 8.65541 15.0957C8.47681 15.0213 8.28585 14.9811 8.09243 14.9771C7.96477 14.9831 7.8376 14.9576 7.72205 14.9031C7.64192 14.7966 7.58811 14.6728 7.565 14.5416C7.52527 14.3532 7.44984 14.1742 7.34277 14.0141C7.2124 13.8648 7.05445 13.7421 6.87757 13.6527C6.74424 13.5756 6.60497 13.4956 6.58127 13.4156C6.55033 13.2871 6.55033 13.153 6.58127 13.0245C6.62132 12.8353 6.62534 12.6403 6.59312 12.4497ZM10.4451 16.9446C10.4037 16.9238 10.3581 16.9129 10.3118 16.9129C10.2654 16.9129 10.2198 16.9238 10.1784 16.9446L8.23169 17.9135V15.5846C8.28784 15.5898 8.34282 15.6038 8.39466 15.626C8.49026 15.6917 8.5752 15.7716 8.64652 15.8631C8.79386 16.0671 9.00094 16.2204 9.23913 16.3016C9.4856 16.3355 9.73646 16.2909 9.95619 16.1742C10.0662 16.121 10.1844 16.0869 10.3058 16.0735C10.4242 16.0879 10.5394 16.122 10.6466 16.1742C10.8178 16.2586 11.0042 16.308 11.1947 16.3194C11.2495 16.3194 11.3042 16.3134 11.3577 16.3016C11.596 16.2205 11.8031 16.0673 11.9503 15.8631C12.0216 15.7716 12.1066 15.6917 12.2022 15.626C12.2538 15.6036 12.309 15.5905 12.3652 15.5875V17.9135L10.4451 16.9446ZM18.8987 15.1342H13.4496C13.5207 14.9996 13.5764 14.8575 13.6156 14.7105C13.642 14.5939 13.686 14.482 13.7459 14.3786C13.8333 14.2952 13.9333 14.2262 14.0422 14.1741C14.2719 14.0713 14.4628 13.898 14.5874 13.6793C14.675 13.444 14.6884 13.1876 14.626 12.9445C14.5995 12.8239 14.5925 12.6999 14.6052 12.5771C14.6459 12.4702 14.7029 12.3702 14.7741 12.2808C14.9347 12.0801 15.0298 11.835 15.0467 11.5785C15.0213 11.3225 14.9178 11.0805 14.7504 10.8852C14.6792 10.7957 14.6222 10.6957 14.5815 10.5889C14.5688 10.4661 14.5758 10.342 14.6023 10.2214C14.6647 9.9783 14.6513 9.72187 14.5637 9.4866C14.4391 9.26796 14.2482 9.09465 14.0185 8.99177C13.9096 8.93969 13.8096 8.87068 13.7222 8.78732C13.6623 8.6839 13.6183 8.57202 13.5919 8.45545C13.5541 8.20741 13.4414 7.97684 13.2689 7.79469C13.0613 7.65349 12.8147 7.58095 12.5637 7.58728C12.4468 7.58753 12.3307 7.56851 12.22 7.53098C12.1244 7.46534 12.0394 7.38539 11.9681 7.29394C11.8208 7.08991 11.6137 6.93667 11.3755 6.85541C11.129 6.82157 10.8782 6.86614 10.6584 6.98282C10.5512 7.03506 10.4361 7.0691 10.3177 7.08356C10.1993 7.0691 10.0841 7.03506 9.97693 6.98282C9.75846 6.8656 9.50836 6.82097 9.26283 6.85541C9.02455 6.9365 8.81743 7.08977 8.67022 7.29394C8.59891 7.38539 8.51396 7.46534 8.41836 7.53098C8.30766 7.56851 8.19153 7.58753 8.07465 7.58728C7.82367 7.58095 7.57703 7.65349 7.36944 7.79469C7.18982 7.97175 7.06794 8.19899 7.0198 8.44657C6.99333 8.56313 6.94937 8.67501 6.88943 8.77843C6.80207 8.86179 6.70206 8.9308 6.59312 8.98288C6.36346 9.08576 6.17251 9.25907 6.04792 9.47771C5.96037 9.71298 5.94693 9.96941 6.0094 10.2125C6.0359 10.3331 6.0429 10.4572 6.03014 10.58C5.98947 10.6869 5.9325 10.7868 5.86125 10.8763C5.69214 11.074 5.58861 11.3194 5.56494 11.5785C5.59039 11.8345 5.69382 12.0765 5.86125 12.2719C5.9325 12.3613 5.98947 12.4613 6.03014 12.5682C6.0429 12.691 6.0359 12.815 6.0094 12.9356C5.94693 13.1787 5.96037 13.4352 6.04792 13.6704C6.17251 13.8891 6.36346 14.0624 6.59312 14.1653C6.70206 14.2173 6.80207 14.2863 6.88943 14.3697C6.94937 14.4731 6.99333 14.585 7.0198 14.7016C7.05078 14.8507 7.09849 14.9958 7.16203 15.1342H1.71297V0.91152H18.8987V15.1342ZM10.3058 14.5416C10.8919 14.5416 11.4647 14.3678 11.952 14.0422C12.4393 13.7166 12.8191 13.2539 13.0433 12.7124C13.2676 12.171 13.3263 11.5752 13.2119 11.0005C13.0976 10.4257 12.8154 9.89771 12.401 9.48332C11.9866 9.06893 11.4587 8.78672 10.8839 8.67239C10.3091 8.55806 9.71334 8.61674 9.17192 8.84101C8.63049 9.06528 8.16772 9.44506 7.84214 9.93233C7.51655 10.4196 7.34277 10.9925 7.34277 11.5785C7.34277 12.3644 7.65495 13.118 8.21063 13.6737C8.76631 14.2294 9.51998 14.5416 10.3058 14.5416ZM10.3058 9.20807C10.7747 9.20807 11.233 9.3471 11.6228 9.60756C12.0126 9.86803 12.3164 10.2382 12.4958 10.6714C12.6752 11.1045 12.7222 11.5811 12.6307 12.041C12.5393 12.5008 12.3135 12.9232 11.982 13.2547C11.6505 13.5862 11.2281 13.8119 10.7683 13.9034C10.3085 13.9949 9.83184 13.9479 9.3987 13.7685C8.96556 13.5891 8.59534 13.2853 8.33488 12.8955C8.07441 12.5056 7.93539 12.0473 7.93539 11.5785C7.93539 10.9498 8.18513 10.3469 8.62967 9.90236C9.07422 9.45781 9.67715 9.20807 10.3058 9.20807ZM4.97233 2.68935C4.97233 2.61077 5.00355 2.5354 5.05912 2.47983C5.11469 2.42426 5.19005 2.39305 5.26864 2.39305H15.343C15.4216 2.39305 15.497 2.42426 15.5525 2.47983C15.6081 2.5354 15.6393 2.61077 15.6393 2.68935C15.6393 2.76794 15.6081 2.8433 15.5525 2.89887C15.497 2.95444 15.4216 2.98566 15.343 2.98566H5.26864C5.19005 2.98566 5.11469 2.95444 5.05912 2.89887C5.00355 2.8433 4.97233 2.76794 4.97233 2.68935ZM4.97233 4.76349C4.97233 4.68491 5.00355 4.60954 5.05912 4.55397C5.11469 4.4984 5.19005 4.46718 5.26864 4.46718H6.75016C6.82875 4.46718 6.90412 4.4984 6.95968 4.55397C7.01525 4.60954 7.04647 4.68491 7.04647 4.76349C7.04647 4.84207 7.01525 4.91744 6.95968 4.97301C6.90412 5.02858 6.82875 5.0598 6.75016 5.0598H5.26864C5.19005 5.0598 5.11469 5.02858 5.05912 4.97301C5.00355 4.91744 4.97233 4.84207 4.97233 4.76349ZM15.6393 5.65241C15.6393 5.73099 15.6081 5.80636 15.5525 5.86193C15.497 5.91749 15.4216 5.94871 15.343 5.94871H11.491C11.4125 5.94871 11.3371 5.91749 11.2815 5.86193C11.226 5.80636 11.1947 5.73099 11.1947 5.65241C11.1947 5.57382 11.226 5.49845 11.2815 5.44289C11.3371 5.38732 11.4125 5.3561 11.491 5.3561H15.343C15.4216 5.3561 15.497 5.38732 15.5525 5.44289C15.6081 5.49845 15.6393 5.57382 15.6393 5.65241Z"
                fill="#667085"
                stroke="#667085"
                stroke-width="0.256264"
              />
            </G>
            <Defs>
              <clipPath id="clip0_12309_62400">
                <Rect
                  width="18.9635"
                  height="18.9635"
                  fill="white"
                  transform="translate(0.828247 0.015686)"
                />
              </clipPath>
            </Defs>
          </Svg>
          <Text
            style={{
              color: "#667085",
              fontSize: "12px",
              fontWeight: 500,
              marginLeft: 5,
              display: "flex",
              justifyContent: "center",
            }}
          >
            Certificate Provided
          </Text>
        </View>
      );
    }
    return null;
  };

  const styles = StyleSheet.create({
    defaultText: {
      fontSize: 14,
    },
    page: {
      flexDirection: "column",
      backgroundSize: "cover",
      position: "relative",
    },
    content: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    textStyle: {
      color: "#142C44",
      textAlign: "center",
      fontFamily: "Poppins",
      fontSize: 39.458,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      textTransform: "uppercase",
    },

    footer: {
      position: "absolute",
      bottom: 20,
      left: 40,
      right: 0,
      textAlign: "left",
    },
    footerText: {
      fontSize: 12,
      color: "#2C4257",
      fontWeight: 500,
    },
    title: { fontSize: 20, fontWeight: "bold", marginBottom: 10 },
    listItem: { marginBottom: 5, fontSize: 14, flex: 1, lineHeight: 1.3 },
    div: {
      margin: 0,
      padding: 0,
    },
    h1: {
      fontSize: 24,
      fontWeight: "bold",
    },
    h2: {
      fontSize: 22,
      fontWeight: "bold",
    },
    h3: {
      fontSize: 18,
      fontWeight: "bold",
    },
    h4: {
      fontSize: 18,
      fontWeight: "bold",
    },
    h5: {
      fontSize: 16,
      fontWeight: "bold",
    },
    h6: {
      fontSize: 14,
      fontWeight: "bold",
    },
    paragraph: {
      fontSize: 14,
      marginBottom: 5,
      padding: 0,
      lineHeight: 1.3,
    },
    bold: {
      fontWeight: "bold",
      color: "#142c44",
    },
    italic: {
      fontStyle: "italic",
    },
    list: {
      marginLeft: 20,
      fontSize: 14,
      lineHeight: 1.3,
    },
    listItemContainer: {
      flexDirection: "row",
    },
    listItemContent: {
      flex: 1,
    },
    bullet: {
      marginRight: 10,
    },
    image: {
      width: 100,
      height: 100, // Adjust based on your needs
      margin: 10,
    },
    link: {
      color: "blue",
      textDecoration: "underline",
    },
    blockquote: {
      margin: 10,
      padding: 10,
      backgroundColor: "#f5f5f5",
      borderLeftWidth: 5,
      borderLeftColor: "#ccc",
    },
  });

  const parseNode = (node: any, key: string, styles: any, index = 0) => {
    const isHeading = (tagName: any) =>
      ["H1", "H2", "H3", "H4", "H5", "H6"].includes(tagName);

    if (isHeading(node.nodeName)) {
      return (
        <Text key={key} style={styles[node.nodeName.toLowerCase()]}>
          {node.textContent}
        </Text>
      );
    }
    if (node.nodeName === "#text" && node.nodeValue.trim() !== "") {
      return (
        <Text key={key} style={styles.defaultText}>
          {node.nodeValue}
        </Text>
      );
    }

    switch (node.nodeName) {
      case "#text":
        return <Text key={key}>{node.nodeValue}</Text>;

      case "UL":
      case "OL":
        let listIndex = 1;
        return (
          <View key={key} style={styles.list}>
            {Array.from(node.childNodes).map((childNode) => {
              const child = childNode as Node;
              if (child.nodeName === "LI") {
                const item = parseNode(
                  child,
                  `${key}-li-${listIndex}`,
                  styles,
                  listIndex
                );
                listIndex++;
                return item;
              } else {
                return parseNode(child, `${key}-li-${listIndex}`, styles);
              }
            })}
          </View>
        );

      case "LI":
        return (
          <View key={key} style={styles.listItemContainer}>
            <Text style={styles.bullet}>
              {node.parentNode.nodeName === "OL" ? `${index}.` : "•"}
            </Text>
            <View style={styles.listItemContent}>
              {Array.from(node.childNodes).map((child, idx) =>
                parseNode(child, `${key}-lichild-${idx}`, styles)
              )}
            </View>
          </View>
        );

      case "P":
        return (
          <Text key={key} style={styles.paragraph}>
            {Array.from(node.childNodes).map((child, idx) =>
              parseNode(child, `${key}-pchild-${idx}`, styles)
            )}
          </Text>
        );

      case "STRONG":
        return (
          <Text key={key} style={styles.bold}>
            {Array.from(node.childNodes).map((child, idx) =>
              parseNode(child, `${key}-strongchild-${idx}`, styles)
            )}
          </Text>
        );

      case "EM":
        return (
          <Text key={key} style={styles.italic}>
            {Array.from(node.childNodes).map((child, idx) =>
              parseNode(child, `${key}-emchild-${idx}`, styles)
            )}
          </Text>
        );

      case "IMG":
        return <Image key={key} src={node.src} style={styles.image} />;

      case "DIV":
        return (
          <View key={key} style={styles.div}>
            {Array.from(node.childNodes).map((child, idx) =>
              parseNode(child, `${key}-divchild-${idx}`, styles)
            )}
          </View>
        );
      case "BLOCKQUOTE":
        return (
          <View
            key={key}
            style={
              node.nodeName === "BLOCKQUOTE"
                ? styles.blockquote
                : { margin: 0, padding: 0 }
            }
          >
            {Array.from(node.childNodes).map((child, idx) =>
              parseNode(child, `${key}-divchild-${idx}`, styles)
            )}
          </View>
        );

      case "A":
        return (
          <Link key={key} src={node.href} style={styles.link}>
            {node.textContent}
          </Link>
        );

      default:
        console.warn(`Unhandled node type: ${node.nodeName}`);
        return null;
    }
  };

  const parseHtml = (input: string, styles: any) => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(input, "text/html");

    // Map through each child node, and filter out any null results
    const content: JSX.Element[] = Array.from(parsedHtml.body.childNodes)
      .map((node, idx) => parseNode(node, idx.toString(), styles))
      .filter((el): el is JSX.Element => el !== null);

    return content;
  };

  return (
    <Document>
      <Page
        size="A4"
        orientation="landscape"
        style={{
          flexDirection: "column",
          position: "relative",
        }}
      >
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
          }}
        >
          <PageBackground />
        </View>

        <View
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            textAlign: "center",
          }}
        >
          {hasLogo && (
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10 10 0 10",
                padding: 10,
              }}
            >
              <Image
                src={hasLogo ? instituteDetails?.logo : null}
                style={{ width: "70px", height: "60px" }}
              />
            </View>
          )}

          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 10,
            }}
          >
            <Text
              style={{
                color: "#142C44",
                textAlign: "center",
                fontSize: "39.458px",
                fontWeight: 700,
                textTransform: "uppercase",
                lineHeight: 1,
                margin: 0,
              }}
            >
              {instituteDetails?.instituteName}
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              margin: 0,
              marginTop: 25,
            }}
          >
            <Svg width="14" height="12" viewBox="0 0 14 12">
              <G clip-path="url(#clip0_12309_62265)">
                <Path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.83043 1.3114H11.594C12.2652 1.3114 12.8144 1.8484 12.8144 2.50473V9.66468C12.8144 10.321 12.2652 10.858 11.594 10.858H1.83043C1.15919 10.858 0.609985 10.321 0.609985 9.66468V2.50473C0.609985 1.8484 1.15919 1.3114 1.83043 1.3114Z"
                  stroke="#142C44"
                  stroke-width="0.805495"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <Path
                  d="M12.8144 2.50104L6.71222 6.67768L0.609985 2.50104"
                  stroke="#142C44"
                  stroke-width="0.805495"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </G>
              <Defs>
                <clipPath id="clip0_12309_62265">
                  <Rect
                    width="13.4249"
                    height="10.7399"
                    fill="white"
                    transform="translate(0 0.717651)"
                  />
                </clipPath>
              </Defs>
            </Svg>
            <Text
              style={{
                color: "#142C44",
                fontSize: "16.11px",
                fontWeight: 400,
                textTransform: "lowercase",
                marginRight: "12px",
                marginLeft: "6px",
              }}
            >
              {instituteDetails?.instituteEmail}
            </Text>
            <Svg width="17" height="17" viewBox="0 0 17 17">
              <G clip-path="url(#clip0_12309_62261)">
                <Path
                  d="M14.6433 11.6291C15.2484 10.5449 15.5661 9.32398 15.5661 8.08239C15.5661 6.8408 15.2484 5.61985 14.6433 4.5357C14.6402 4.50044 14.6294 4.46629 14.6118 4.43561C14.5941 4.40492 14.57 4.37844 14.5411 4.35798C13.725 2.98229 12.4797 1.91273 10.9965 1.31375C9.51335 0.714758 7.87451 0.619503 6.33194 1.04262C4.78938 1.46575 3.42848 2.38382 2.4585 3.6557C1.48851 4.92758 0.963135 6.48284 0.963135 8.08239C0.963135 9.68193 1.48851 11.2372 2.4585 12.5091C3.42848 13.781 4.78938 14.699 6.33194 15.1222C7.87451 15.5453 9.51335 15.45 10.9965 14.851C12.4797 14.252 13.725 13.1825 14.5411 11.8068C14.57 11.7863 14.5941 11.7599 14.6118 11.7292C14.6294 11.6985 14.6402 11.6643 14.6433 11.6291ZM4.08279 11.8581H5.2354C5.47674 12.808 5.91791 13.6955 6.52948 14.4614C5.45384 13.8811 4.59535 12.9677 4.08279 11.8581ZM1.47626 8.33411H2.73333C2.75629 9.36679 2.95409 10.3881 3.31833 11.3547H2.31146C1.79986 10.4273 1.51375 9.39257 1.47626 8.33411ZM2.31196 4.81007H3.31883C2.95459 5.77666 2.75679 6.79799 2.73384 7.83067H1.47626C1.5139 6.77217 1.80019 5.73739 2.31196 4.81007ZM12.4499 4.30663H11.2973C11.0559 3.35673 10.6147 2.46923 10.0032 1.70338C11.0788 2.28369 11.9373 3.19711 12.4499 4.30663ZM15.0564 7.83067H13.7993C13.7764 6.79799 13.5786 5.77666 13.2143 4.81007H14.2212C14.7328 5.73744 15.0189 6.77221 15.0564 7.83067ZM13.2959 7.83067H11.7873C11.7765 6.81382 11.656 5.80111 11.4281 4.81007H12.6769C13.063 5.77157 13.2727 6.79479 13.2959 7.83067ZM8.01461 4.81007V7.83067H5.24874C5.26222 6.81252 5.39108 5.79918 5.63286 4.81007H8.01461ZM5.77181 4.30663C6.27525 2.64883 7.09383 1.49319 8.01461 1.31271V4.30663H5.77181ZM8.01461 8.33411V11.3547H5.63286C5.39108 10.3656 5.26222 9.35226 5.24874 8.33411H8.01461ZM8.01461 11.8581V14.8521C7.09383 14.6716 6.2755 13.516 5.77181 11.8581H8.01461ZM8.51804 11.3547V8.33411H11.2839C11.2704 9.35226 11.1416 10.3656 10.8998 11.3547H8.51804ZM10.7608 11.8581C10.2574 13.516 9.43857 14.6716 8.51804 14.8521V11.8581H10.7608ZM8.51804 7.83067V4.81007H10.8998C11.1416 5.79918 11.2704 6.81252 11.2839 7.83067H8.51804ZM8.51804 4.30663V1.31271C9.43857 1.49319 10.2569 2.64883 10.7608 4.30663H8.51804ZM6.52948 1.70338C5.91791 2.46923 5.47674 3.35673 5.2354 4.30663H4.08279C4.59535 3.19711 5.45384 2.28369 6.52948 1.70338ZM5.10426 4.81007C4.87646 5.80112 4.75611 6.81383 4.74531 7.83067H3.23677C3.25985 6.79481 3.46944 5.77158 3.85549 4.81007H5.10426ZM3.23677 8.33411H4.74531C4.75611 9.35095 4.87646 10.3637 5.10426 11.3547H3.85549C3.46944 10.3932 3.25985 9.36997 3.23677 8.33411ZM10.0032 14.4614C10.6147 13.6955 11.0559 12.808 11.2973 11.8581H12.4499C11.9373 12.9677 11.0788 13.8811 10.0032 14.4614ZM11.4281 11.3547C11.656 10.3637 11.7765 9.35095 11.7873 8.33411H13.2959C13.2727 9.36999 13.063 10.3932 12.6769 11.3547H11.4281ZM13.7993 8.33411H15.0564C15.0188 9.39261 14.7325 10.4274 14.2207 11.3547H13.2138C13.5782 10.3882 13.7762 9.36682 13.7993 8.33411ZM13.9141 4.30663H13.0041C12.6192 3.44681 12.0624 2.67483 11.368 2.03816C12.3945 2.56736 13.2704 3.34775 13.9141 4.30663ZM5.16442 2.03816C4.47019 2.67491 3.91349 3.44687 3.52851 4.30663H2.61855C3.26215 3.34776 4.13797 2.56737 5.16442 2.03816ZM2.61855 11.8581H3.52851C3.91356 12.7179 4.47035 13.4899 5.16467 14.1266C4.13813 13.5974 3.26222 12.8171 2.61855 11.8581ZM11.368 14.1266C12.0624 13.49 12.6192 12.718 13.0041 11.8581H13.9141C13.2704 12.817 12.3945 13.5974 11.368 14.1266Z"
                  fill="#142C44"
                  fill-opacity="0.7"
                />
              </G>
              <Defs>
                <clipPath id="clip0_12309_62261">
                  <Rect
                    width="16.1099"
                    height="16.1099"
                    fill="white"
                    transform="translate(0.210938 0.0215454)"
                  />
                </clipPath>
              </Defs>
            </Svg>
            <Text
              style={{
                color: "#142C44",
                fontSize: "16.11px",
                fontWeight: 400,
                textTransform: "lowercase",
                marginLeft: "6px",
              }}
            >
              {instituteDetails?.website}
            </Text>
          </View>
        </View>
      </Page>

      <Page
        size="A4"
        orientation="landscape"
        style={{ flexDirection: "column", position: "relative" }}
      >
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
          }}
        >
          <CourseBackground />
        </View>

        <View
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            margin: "10 10 10 30",
            padding: 10,
            width: "55%",
          }}
        >
          <Text
            style={{
              color: "#142C44",
              fontSize: "40px",
              fontWeight: 700,
              textTransform: "uppercase",
              marginBottom: "20px",
            }}
          >
            {courseDetails?.courseName}
          </Text>
          <View
            style={{
              flexDirection: "row",
            }}
          >
            {renderCertificateTag()}

            <View
              style={{
                flexDirection: "row",
                backgroundColor: "#E7E9EA",
                borderRadius: "4.813px",
                padding: 5,
                marginLeft: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Svg width="19" height="18" viewBox="0 0 19 18">
                <G clip-path="url(#clip0_12309_62408)">
                  <Path
                    d="M16.2613 0.579285H2.2469C1.87535 0.57973 1.51915 0.727524 1.25642 0.99025C0.993699 1.25298 0.845904 1.60918 0.845459 1.98073V12.6317C0.845904 13.0033 0.993699 13.3595 1.25642 13.6222C1.51915 13.8849 1.87535 14.0327 2.2469 14.0332H6.99079C6.77917 14.6778 6.26989 15.2319 5.77574 15.7149H5.33008C5.10707 15.7149 4.89319 15.8035 4.7355 15.9612C4.57781 16.1189 4.48921 16.3327 4.48921 16.5558V17.1163C4.48921 17.1907 4.51874 17.262 4.57131 17.3145C4.62387 17.3671 4.69517 17.3966 4.7695 17.3966H13.7387C13.8131 17.3966 13.8844 17.3671 13.9369 17.3145C13.9895 17.262 14.019 17.1907 14.019 17.1163V16.5558C14.019 16.3327 13.9304 16.1189 13.7728 15.9612C13.6151 15.8035 13.4012 15.7149 13.1782 15.7149H12.7325C12.2384 15.2319 11.7291 14.6778 11.5175 14.0332H16.2613C16.6329 14.0327 16.9891 13.8849 17.2518 13.6222C17.5146 13.3595 17.6623 13.0033 17.6628 12.6317V1.98073C17.6623 1.60918 17.5146 1.25298 17.2518 0.99025C16.9891 0.727524 16.6329 0.57973 16.2613 0.579285ZM13.1782 16.2755C13.2525 16.2755 13.3238 16.305 13.3764 16.3576C13.4289 16.4101 13.4585 16.4814 13.4585 16.5558V16.836H5.04979V16.5558C5.04979 16.4814 5.07932 16.4101 5.13189 16.3576C5.18445 16.305 5.25574 16.2755 5.33008 16.2755H13.1782ZM11.9508 15.7149H6.55747C7.02849 15.2463 7.37654 14.6686 7.57071 14.0332H10.9375C11.1317 14.6686 11.4798 15.2463 11.9508 15.7149ZM17.1022 12.6317C17.1022 12.8547 17.0136 13.0686 16.8559 13.2263C16.6982 13.384 16.4844 13.4726 16.2613 13.4726H2.2469C2.02389 13.4726 1.81001 13.384 1.65232 13.2263C1.49463 13.0686 1.40604 12.8547 1.40604 12.6317V11.7908H17.1022V12.6317ZM17.1022 11.2303H1.40604V1.98073C1.40604 1.75772 1.49463 1.54384 1.65232 1.38615C1.81001 1.22845 2.02389 1.13986 2.2469 1.13986H16.2613C16.4844 1.13986 16.6982 1.22845 16.8559 1.38615C17.0136 1.54384 17.1022 1.75772 17.1022 1.98073V11.2303Z"
                    fill="#667085"
                    stroke="#667085"
                    stroke-width="0.256264"
                  />
                  <Path
                    d="M9.25441 12.913C9.40921 12.913 9.5347 12.7875 9.5347 12.6327C9.5347 12.4779 9.40921 12.3524 9.25441 12.3524C9.09961 12.3524 8.97412 12.4779 8.97412 12.6327C8.97412 12.7875 9.09961 12.913 9.25441 12.913Z"
                    fill="#667085"
                  />
                  <Path
                    d="M11.8578 6.07928L8.01384 4.15729C7.95524 4.12798 7.89011 4.11414 7.82466 4.11709C7.7592 4.12003 7.69558 4.13966 7.63984 4.1741C7.5841 4.20855 7.53809 4.25667 7.50618 4.3139C7.47427 4.37113 7.45752 4.43556 7.45752 4.50108V8.34507C7.45752 8.41059 7.47427 8.47503 7.50618 8.53226C7.53809 8.58948 7.5841 8.63761 7.63984 8.67205C7.69558 8.7065 7.7592 8.72612 7.82466 8.72907C7.89011 8.73201 7.95524 8.71817 8.01384 8.68886L11.8578 6.76687C11.9217 6.73494 11.9754 6.68587 12.0129 6.62515C12.0504 6.56443 12.0703 6.49446 12.0703 6.42308C12.0703 6.3517 12.0504 6.28173 12.0129 6.22101C11.9754 6.16028 11.9217 6.11121 11.8578 6.07928ZM8.22632 7.72311V5.12304L10.8263 6.42308L8.22632 7.72311Z"
                    fill="#667085"
                    stroke="#F5F5F5"
                    stroke-width="0.102506"
                  />
                </G>
                <Defs>
                  <clipPath id="clip0_12309_62408">
                    <Rect
                      width="17.9385"
                      height="17.9385"
                      fill="white"
                      transform="translate(0.285156 0.015686)"
                    />
                  </clipPath>
                </Defs>
              </Svg>
              <Text
                style={{
                  color: "#667085",
                  fontSize: "12px",
                  fontWeight: 500,
                  marginLeft: 5,
                }}
              >
                {courseDetails?.courseLevel.courseLevelName}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.footer}>
          <Text style={styles.footerText}> {instituteDetails?.website}</Text>
        </View>
      </Page>
      <Page
        size="A4"
        orientation="landscape"
        style={{
          flexDirection: "column",
          position: "relative",
          // paddingTop: 0,
          paddingTop: 30,
        }}
        // wrap={false}
      >
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          fixed
        >
          <PageBackground />
        </View>
        <View
          style={{
            flexDirection: "row",
            margin: "30 30 0 30",
            padding: 10,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Svg width="35" height="35" viewBox="0 0 35 35">
            <Circle cx="17.1762" cy="17.1762" r="17.1762" fill="#193048" />
            <Path
              d="M23.497 26.7844H10.7934C10.4154 26.7835 10.0532 26.6328 9.78604 26.3655C9.51888 26.0981 9.36854 25.7358 9.36792 25.3578V9.76879C9.3686 9.39066 9.51913 9.02821 9.78653 8.76085C10.0539 8.4935 10.4164 8.34303 10.7945 8.34241H15.6574C15.7569 8.34241 15.8522 8.3819 15.9225 8.45219C15.9928 8.52248 16.0323 8.61781 16.0323 8.71722C16.0323 8.81662 15.9928 8.91196 15.9225 8.98225C15.8522 9.05254 15.7569 9.09202 15.6574 9.09202H10.7934C10.6141 9.09246 10.4423 9.16393 10.3156 9.29078C10.189 9.41763 10.1177 9.58952 10.1175 9.76879V25.3578C10.1177 25.5373 10.1891 25.7094 10.316 25.8363C10.443 25.9632 10.615 26.0346 10.7945 26.0348H23.4982C23.6777 26.0346 23.8498 25.9632 23.9767 25.8363C24.1036 25.7094 24.175 25.5373 24.1752 25.3578V9.76879C24.175 9.58932 24.1036 9.41725 23.9767 9.29037C23.8498 9.16348 23.6777 9.09215 23.4982 9.09202H18.6353C18.5359 9.09202 18.4406 9.05254 18.3703 8.98225C18.3 8.91196 18.2605 8.81662 18.2605 8.71722C18.2605 8.61781 18.3 8.52248 18.3703 8.45219C18.4406 8.3819 18.5359 8.34241 18.6353 8.34241H23.497C23.8752 8.34303 24.2376 8.4935 24.505 8.76085C24.7724 9.02821 24.923 9.39066 24.9237 9.76879V25.3578C24.923 25.736 24.7725 26.0985 24.5051 26.3659C24.2377 26.6333 23.8752 26.7838 23.497 26.7844Z"
              fill="white"
              fill-opacity="0.8"
            />
            <Path
              d="M17.6782 11.443H16.6143C16.2609 11.4424 15.9222 11.3017 15.6723 11.0518C15.4225 10.802 15.2819 10.4632 15.2813 10.1099V7.66564C15.2813 7.56624 15.3208 7.4709 15.3911 7.40061C15.4614 7.33032 15.5567 7.29083 15.6561 7.29083H18.6363C18.7358 7.29083 18.8311 7.33032 18.9014 7.40061C18.9717 7.4709 19.0112 7.56624 19.0112 7.66564V10.1099C19.0106 10.4632 18.87 10.802 18.6202 11.0518C18.3703 11.3017 18.0316 11.4424 17.6782 11.443ZM16.031 8.04045V10.1099C16.0311 10.2645 16.0926 10.4128 16.202 10.5222C16.3113 10.6316 16.4596 10.6931 16.6143 10.6934H17.6782C17.8329 10.6931 17.9812 10.6316 18.0905 10.5222C18.1998 10.4128 18.2614 10.2645 18.2615 10.1099V8.04045H16.031ZM18.3749 15.1471H12.8465C12.7471 15.1471 12.6517 15.1076 12.5815 15.0373C12.5112 14.967 12.4717 14.8717 12.4717 14.7723C12.4717 14.6728 12.5112 14.5775 12.5815 14.5072C12.6517 14.4369 12.7471 14.3974 12.8465 14.3974H18.3749C18.4743 14.3974 18.5697 14.4369 18.6399 14.5072C18.7102 14.5775 18.7497 14.6728 18.7497 14.7723C18.7497 14.8717 18.7102 14.967 18.6399 15.0373C18.5697 15.1076 18.4743 15.1471 18.3749 15.1471ZM20.2738 17.5454H12.8479C12.7485 17.5454 12.6532 17.5059 12.5829 17.4356C12.5126 17.3653 12.4731 17.27 12.4731 17.1706C12.4731 17.0712 12.5126 16.9758 12.5829 16.9055C12.6532 16.8352 12.7485 16.7957 12.8479 16.7957H20.2738C20.3732 16.7957 20.4685 16.8352 20.5388 16.9055C20.6091 16.9758 20.6486 17.0712 20.6486 17.1706C20.6486 17.27 20.6091 17.3653 20.5388 17.4356C20.4685 17.5059 20.3732 17.5454 20.2738 17.5454ZM21.4451 19.6743H12.8479C12.7485 19.6743 12.6532 19.6348 12.5829 19.5645C12.5126 19.4942 12.4731 19.3989 12.4731 19.2995C12.4731 19.2001 12.5126 19.1047 12.5829 19.0344C12.6532 18.9642 12.7485 18.9247 12.8479 18.9247H21.4451C21.5445 18.9247 21.6398 18.9642 21.7101 19.0344C21.7804 19.1047 21.8199 19.2001 21.8199 19.2995C21.8199 19.3989 21.7804 19.4942 21.7101 19.5645C21.6398 19.6348 21.5445 19.6743 21.4451 19.6743Z"
              fill="white"
              fill-opacity="0.8"
            />
          </Svg>
          <Text
            style={{
              color: "#142C44",
              fontSize: "24px",
              fontWeight: 600,
              marginLeft: 10,
            }}
          >
            Description
          </Text>
        </View>
        <View style={{ margin: "30px" }}>
          {/* Inner View for content */}
          <View
            style={{
              padding: 10,
              color: "rgba(20, 44, 68, 0.70)",
            }}
          >
            {parseHtml(courseDetails?.courseDescription, styles)}
          </View>
        </View>
      </Page>
      <Page
        size="A4"
        orientation="landscape"
        style={{ flexDirection: "column", position: "relative" }}
      >
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
          }}
        >
          <PageBackground />
        </View>

        <View style={{ flexDirection: "column" }}>
          <View
            style={{
              flexDirection: "row",
              margin: "65 30 0 30",
              padding: 10,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Svg width="35" height="35" viewBox="0 0 35 35">
              <Circle cx="17.1762" cy="17.1762" r="17.1762" fill="#193048" />
              <Path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.3774 23.5659C23.3774 23.7601 23.22 23.9175 23.0267 23.9175H14.909C14.7143 23.9175 14.5569 23.7601 14.5569 23.5659C14.5569 23.3717 14.7143 23.2144 14.909 23.2144H23.0267C23.22 23.2144 23.3774 23.3716 23.3774 23.5659ZM23.3774 21.4674C23.3774 21.6616 23.22 21.8189 23.0267 21.8189H14.909C14.7143 21.8189 14.5569 21.6616 14.5569 21.4674C14.5569 21.2731 14.7143 21.1158 14.909 21.1158H23.0267C23.22 21.1158 23.3774 21.2732 23.3774 21.4674ZM23.3774 16.4506C23.3774 16.6448 23.22 16.8022 23.0267 16.8022H14.909C14.7143 16.8022 14.5569 16.6448 14.5569 16.4506C14.5569 16.2566 14.7143 16.0989 14.909 16.0989H23.0267C23.22 16.0989 23.3774 16.2566 23.3774 16.4506ZM23.3774 18.5494C23.3774 18.7434 23.22 18.9009 23.0267 18.9009H14.909C14.7143 18.9009 14.5569 18.7434 14.5569 18.5494C14.5569 18.3552 14.7143 18.1978 14.909 18.1978H23.0267C23.22 18.1978 23.3774 18.3552 23.3774 18.5494ZM12.7732 23.7262C12.7732 23.7332 12.7663 23.7403 12.7581 23.7403H10.3393C10.3324 23.7403 10.3255 23.7332 10.3255 23.7262V21.3071C10.3255 21.3001 10.3324 21.293 10.3393 21.293H12.7581C12.7664 21.293 12.7732 21.3001 12.7732 21.3071V23.7262ZM12.7581 20.5899H10.3393C9.94448 20.5899 9.6228 20.9116 9.6228 21.3071V23.7262C9.6228 24.1217 9.94448 24.4434 10.3393 24.4434H12.7581C13.1543 24.4434 13.476 24.1217 13.476 23.7262V21.3071C13.476 20.9116 13.1543 20.5899 12.7581 20.5899ZM12.7732 18.7093C12.7732 18.7163 12.7663 18.7238 12.7581 18.7238H10.3393C10.3324 18.7238 10.3255 18.7163 10.3255 18.7093V16.2903C10.3255 16.2837 10.3324 16.2762 10.3393 16.2762H12.7581C12.7664 16.2762 12.7732 16.2837 12.7732 16.2903V18.7093ZM12.7581 15.5731H10.3393C9.94448 15.5731 9.6228 15.8952 9.6228 16.2903V18.7093C9.6228 19.1049 9.94448 19.427 10.3393 19.427H12.7581C13.1543 19.427 13.476 19.1049 13.476 18.7093V16.2903C13.476 15.8951 13.1543 15.5731 12.7581 15.5731ZM23.3774 13.5326C23.3774 13.7268 23.22 13.8841 23.0267 13.8841H14.909C14.7143 13.8841 14.5569 13.7269 14.5569 13.5326C14.5569 13.3383 14.7143 13.1811 14.909 13.1811H23.0267C23.22 13.1811 23.3774 13.3383 23.3774 13.5326ZM14.557 11.4341C14.557 11.2399 14.7143 11.0825 14.909 11.0825H23.0268C23.22 11.0825 23.3774 11.2399 23.3774 11.4341C23.3774 11.6284 23.22 11.7856 23.0268 11.7856H14.909C14.7143 11.7856 14.557 11.6284 14.557 11.4341ZM12.7732 13.6929C12.7732 13.6999 12.7663 13.707 12.7581 13.707H10.3393C10.3324 13.707 10.3255 13.6999 10.3255 13.6929V11.2738C10.3255 11.2668 10.3324 11.2598 10.3393 11.2598H12.7581C12.7664 11.2598 12.7732 11.2668 12.7732 11.2738V13.6929ZM12.7581 10.5566H10.3393C9.94448 10.5566 9.6228 10.8783 9.6228 11.2739V13.6929C9.6228 14.0884 9.94448 14.4101 10.3393 14.4101H12.7581C13.1543 14.4101 13.476 14.0884 13.476 13.6929V11.2739C13.476 10.8783 13.1543 10.5566 12.7581 10.5566Z"
                fill="white"
              />
            </Svg>

            <Text
              style={{
                color: "#142C44",
                fontSize: "24px",
                fontWeight: 600,
                marginLeft: 10,
              }}
            >
              Index
            </Text>
          </View>

          <View
            style={{
              margin: "0 30 30 30",
              padding: 10,
              flexDirection: "column",
            }}
          >
            {courseDetails &&
              courseDetails?.courseSyllabus.map((item: any, index: any) => (
                <Text
                  key={index}
                  style={{
                    color: "rgba(20, 44, 68, 0.70)",
                    fontSize: "14px",
                    fontWeight: 400,
                    marginBottom: "6px",
                  }}
                >
                  • {convertHtmlToText(item?.chapterName)}
                </Text>
              ))}
          </View>
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}> {instituteDetails?.website}</Text>
        </View>
      </Page>
      {courseDetails &&
        courseDetails?.courseSyllabus.map((item: any, index: any) => (
          <Page
            key={index}
            size="A4"
            orientation="landscape"
            style={{
              flexDirection: "column",
              position: "relative",
              paddingTop: 0,
            }}
          >
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                zIndex: -1,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              fixed
            >
              <PageBackground />
            </View>

            <View style={{ margin: "30 30 30 30", padding: 10 }}>
              <View
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  marginBottom: 20,
                  gap: "8px",
                  marginTop: "30",
                }}
              >
                <View
                  style={{
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Svg
                    width="30"
                    height="32"
                    viewBox="0 0 30 32"
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                    }}
                  >
                    <Path
                      d="M29.3441 16.0175C29.3441 24.4001 19.1297 31.1955 10.7883 31.1955C2.44679 31.1955 0 24.4001 0 16.0175C0 7.63494 2.44679 0.839539 10.7883 0.839539C19.1297 0.839539 29.3441 7.63494 29.3441 16.0175Z"
                      fill="#11C89B"
                    />
                  </Svg>
                  <Text style={{ color: "#FCFCFC" }}>{index + 1}</Text>
                </View>
                <View>
                  <Text style={{ color: "#11C89B" }}>Chapter</Text>
                </View>
              </View>
              <Text
                style={{
                  color: "#142C44",
                  fontSize: "22px",
                  fontWeight: 600,
                  marginBottom: "20px",
                }}
              >
                {convertHtmlToText(item?.chapterName)}
              </Text>
              <View
                style={{
                  padding: 10,
                  color: "rgba(20, 44, 68, 0.70)",
                }}
              >
                {parseHtml(item?.chapterDetails, styles)}
              </View>
            </View>
            <View style={styles.footer}>
              <Text style={styles.footerText}>{instituteDetails?.website}</Text>
            </View>
          </Page>
        ))}
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            width: "100%",
            height: "100%",
          }}
        >
          <PageBackground />
        </View>
        <View
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 10,
          }}
        >
          <Image src={nurtureLogo} style={{ width: "42px", height: "42px" }} />

          <Text
            style={{
              padding: "12px 0",
              color: "#11c89b",
              fontSize: "22px",
              fontWeight: 600,
            }}
          >
            Happy Learning..
          </Text>
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}> {instituteDetails?.website}</Text>
        </View>
      </Page>
    </Document>
  );
}

export default CoursePdf;
